import { createElement } from "react";
// Bundled fallback; the shared master copy from wannlabs.com (index.html) wins if it loads first (guarded by customElements.get).
import "../lib/wannlabs/wl-apps.js";

/** The standard Wannlabs "Apps" switcher (shared wl-apps web component, loaded from https://wannlabs.com/assets/wl-apps.js in index.html), Prime highlighted, plus About Prime. */
export function WannlabsSwitcher() {
  return createElement("wl-apps", {
    current: "prime",
    theme: "light",
    "extra-label": "About Prime",
    "extra-href": "https://wannlabs.com/prime/",
  });
}
